function ScrollDownButton(el) {
    el.addEventListener('click', e => {
        e.preventDefault();
        window.scrollTo({top: window.innerHeight, behavior: 'smooth'});
    });
}

(function() {
    const scrollDownBtns = document.querySelectorAll('.jsScrollDownBtn');
    for (let i = 0; i < scrollDownBtns.length; i++) new ScrollDownButton(scrollDownBtns[i]);
})();
